import React, { useEffect, useRef } from 'react'
import titleVideo from '../../../assets/video/MobileShowreel.mp4';
import titleImage from '../../../assets/image/MobileBG.png';
import Canvas from '../../Desktop/Title/canvas';

interface Props {
  handleNextStep: () => void;
}

export default function Title(props: Props) {
  const { handleNextStep } = props;

  const canvasElementRef = useRef<HTMLCanvasElement>(null)
  const canvasRef = useRef<Canvas | null>(null);
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    // console.log("Mounting Title component");
    let animationFrameId = 0
    const videoElement = videoRef.current

    const renderCanvas = () => {
      if (canvasRef.current) {
        canvasRef.current.render();
        animationFrameId = requestAnimationFrame(renderCanvas);
      }
    };

    function setupRenderCanvas() {
      if (!canvasRef.current && canvasElementRef.current) {
        // console.log('setting up render canvas...')
        canvasRef.current = new Canvas(true, canvasElementRef.current);
        renderCanvas();
      }
    }

    const handleTouchMove = (e: any) => {
      e.preventDefault();
    };

    // Setup render canvas upon video loaded and begun playing
    if (videoElement) {
      videoElement.addEventListener('playing', setupRenderCanvas);
    }

    // Disable default behaviour for touchmove event
    document.body.style.overflow = 'hidden'; // GX: why is this js and not css?
    window.addEventListener('touchmove', handleTouchMove, { passive: false });

    return () => {
      // console.log('Unmounting Title component...')
      document.body.style.overflow = 'auto';
      window.removeEventListener('touchmove', handleTouchMove);

      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }

      if (videoElement) {
        videoElement.removeEventListener('playing', setupRenderCanvas);
      }

      canvasRef.current?.dispose();
      canvasRef.current = null;
    }
  }, []);

  return (
    <div className={'div-loading-container'}>
      <div className='title-mobile'
        style={{
          height: window.innerHeight,
          width: window.innerWidth,
          // '--offset-from-top': `${-(window.innerHeight - heightContent) * 0.5}px`,
          // '--offset-from-left': `${-(window.innerWidth - widthContent) * 0.5}px`,
        } as React.CSSProperties}
      >
        <div id='app'>
          <div className='container'>
            <div className='wrapper'>
              <div className='video-container'>
                <video className='title-video-player'
                  ref={videoRef}
                  autoPlay
                  preload='metadata'
                  loop
                  muted
                  playsInline
                  src={titleVideo}
                  data-hover={titleImage}
                  style={{
                    width: window.innerWidth,
                    height: window.innerHeight
                  }}
                />
              </div>
            </div>
          </div>
          <canvas ref={canvasElementRef} id="webgl" />
        </div>
      </div>
    </div>
  )
};

